import { render, staticRenderFns } from "./Wolman.vue?vue&type=template&id=09696924&scoped=true"
import script from "./Wolman.vue?vue&type=script&lang=js"
export * from "./Wolman.vue?vue&type=script&lang=js"
import style0 from "./Wolman.vue?vue&type=style&index=0&id=09696924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09696924",
  null
  
)

export default component.exports